export enum ECheckAccountTypeEnum {
    Checking = "Checking",
    Savings = "Savings",
}